import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { ChangeUserRoleInput, UserSummary } from "./types";
import { USERS_LIST_QUERY_KEY, USER_DETAIL_QUERY_KEY } from "./constants";

interface ChangeUserRoleParams {
  readonly id: string;
  readonly input: ChangeUserRoleInput;
}

async function changeUserRole({ id, input }: ChangeUserRoleParams): Promise<UserSummary> {
  return httpClient<UserSummary>(`/api/admin/users/${encodeURIComponent(id)}/role`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function useChangeUserRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: changeUserRole,
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: USERS_LIST_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: [...USER_DETAIL_QUERY_KEY, id] });
    },
  });
}
